import { DEVICE_TYPE } from "src/module/const";
import style from "./estimate.css";

const kzs = window.kzs;
const $ = kzs.$;

const carNameToIdMap = {
  レイバック: 88,
  フォレスター: 68,
  インプレッサ: 86,
  クロストレック: 84,
  "レガシィ アウトバック": 62,
  レヴォーグ: 55,
  ソルテラ: 83,
  "WRX S4": 59,
  "SUBARU BRZ": 35,
  ジャスティ: 75,
  レックス: 85,
  シフォン: 78,
  ステラ: 53,
  プレオプラス: 38,
  サンバーバン: 70,
  サンバートラック: 69,
};

const carNameToId = (carName: string): number | undefined => {
  const carNameToIdMapKeys = Object.keys(carNameToIdMap);
  const carNameToIdMapKey = carNameToIdMapKeys.find((key) => carName.includes(key)) as
    | keyof typeof carNameToIdMap
    | undefined;

  if (!carNameToIdMapKey) return undefined;
  return carNameToIdMap[carNameToIdMapKey] as number;
};

interface EstimateData {
  name?: string;
  href?: string;
  price?: string;
  updatedAt?: string;
}

class Estimate {
  setEstimate(estimate: EstimateData) {
    kzs(
      "setUserData",
      {
        kzCarModelEstimateResult: JSON.stringify(estimate),
        __kzCarModelEstimateResult: {
          mode: "prepend", // 最後に追加した情報が先頭に来る (or "append")
          limit: 1, // 履歴の最大保持数 (=最新 10 件だけ保持。指定なしの default は 100)
          unique: true, // 履歴に同じデータがあった際に追加させないモード (default は false)
        },
      },
      () => {
        //
        kzs.console.log(`userData - kzCarModelEstimateResult is set.`);
      }
    );
  }

  getEstimate(): EstimateData {
    if (!kzs.current.userData.kzCarModelEstimateResult?.length) return {};

    const estimate = JSON.parse(kzs.current.userData.kzCarModelEstimateResult) || {};

    return estimate;
  }

  clearEstimate(): void {
    kzs(
      "setUserData",
      {
        kzCarModelEstimateResult: {},
      },
      () => {
        //
        kzs.console.log(`userData - kzCarModelEstimateResult is clear.`);
      }
    );
  }
}

export default new Estimate();

export const updateEstimate = (estimate: Estimate): void => {
  {
    const changeEstimateResult = () => {
      if ($("#menu_result").hasClass("active")) {
        const carModelText: Array<string> = [];
        $(".your_car_container span").each((_i, e) => {
          carModelText.push($(e).text());
        });
        const carModel = carModelText.join(" ");
        const carPrice = $(".price_block .price span").text();

        estimate.setEstimate({
          name: carModel,
          href: location.href,
          price: carPrice,
          updatedAt: new Date().toLocaleString(),
        });
      }
    };
    const element = document.querySelector("#menu_result");

    // 監視ターゲットの取得
    const observeFunc = (element: Element) => {
      // オブザーバーの作成(変化が発生したときの処理)
      const observer = new MutationObserver((_records) => {
        changeEstimateResult();
      });

      // 監視の開始
      observer.observe(element, {
        attributes: true,
        characterData: true,
      });
    };

    if (element) {
      // 監視
      observeFunc(element);
      // 初期表示
      changeEstimateResult();
    }
  }
};

export const showEstimate = (estimate: Estimate): void => {
  style.use();

  const estimateResult = estimate.getEstimate();
  console.log(estimateResult);

  const carId = carNameToId(estimateResult.name || "");

  const deviveType = kzs.navigator.getDeviceType();
  const target = deviveType == DEVICE_TYPE.sp ? ".l-lineup" : "#contents_lineup";

  if (Object.keys(estimateResult).length > 0) {
    kzs("trackClickGoals", 47696);

    const carname = estimateResult.name;
    const price = estimateResult.price;
    // const href = estimateResult.href;
    const href = `https://ap.subaru.jp/search/drivecar/result.html?car_id=${carId}`;

    $(target).before($("<div>", { id: "kz-estimate-result" }));
    $("#kz-estimate-result").append(
      `
      <h2 class="kz-estimate-title">前回のお見積り結果</h2>
      <div class="kz-estimate--box">
        <div class="kz-car-info--box">
          <div class="kz-car-name">${carname}</div>
          <div class="kz-car-price">
            合計金額（税込）
            <span class="kz-car-price--number">${price}</span>
            円
          </div>
        </div>
        <div class="kz-car-reserve--box">
          <div class="kz-car-reserve--label">乗り心地をお試しいただけます</div>
          <a class="kz-car-reserve--button" href="${href}"><img src="/assets/img/footer/icon-car-search.png" alt="試乗車検索/予約">【無料】試乗車予約はこちら</a>
        </div>
      </div>
    `
    );
  }
};
